import { render } from "./Copyboard.vue?vue&type=template&id=3ae7fa94&scoped=true"
import script from "./Copyboard.vue?vue&type=script&lang=ts"
export * from "./Copyboard.vue?vue&type=script&lang=ts"

import "./Copyboard.vue?vue&type=style&index=0&id=3ae7fa94&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3ae7fa94"

export default script